import React, { useEffect } from "react";
import { Box } from "@mui/material";
import ScrollToTopFab from "../../components/ScrollToTopFab";
import WhatsAppFab from "../../components/common/WhatsAppFab";
import PublicNavbar from "../../components/PublicNavbar";
import Footer from "../../components/common/Footer";

// Import extracted components
import { SEOHead } from "../../components/Landing";
import {
  HeroSection,
  ProblemSection,
  HowItWorksSection,
  FeaturesSection,
  ClientsSection,
  TestimonialsSection,
  UserTestimonialsSection,
  ContactFormSection,
  CTASection,
  WhatsAppChatPreview,
} from "../../components/Landing/sections";

/**
 * Landing Page with Animations
 *
 * Main orchestrator for the landing page.
 * All sections are self-contained components - no prop drilling.
 */

const LandingAnimated: React.FC = () => {
  // Enable smooth scroll behavior
  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
    return () => {
      document.documentElement.style.scrollBehavior = "auto";
    };
  }, []);

  return (
    <Box sx={{ overflowX: "hidden" }}>
      {/* SEO Meta Tags */}
      <SEOHead />

      {/* Public Navbar */}
      <PublicNavbar transparent={true} />

      {/* Hero Section with Before/After Animation */}
      <HeroSection />

      {/* Problem Statement - Extracted Component */}
      <ProblemSection />

      {/* How It Works - Extracted Component */}
      <HowItWorksSection />

      {/* WhatsApp Chat Preview */}
      <WhatsAppChatPreview />

      {/* Features - Extracted Component */}
      <FeaturesSection />

      {/* User Testimonials (Shoppers) - Extracted Component */}
      <UserTestimonialsSection />

      {/* Premium Mall Partners - Extracted Component */}
      <ClientsSection />

      {/* Mall Success Stories (B2B Testimonials) - Extracted Component */}
      <TestimonialsSection />

      {/* Contact Form - Self-contained with internal state management */}
      <ContactFormSection />

      {/* CTA - Extracted Component */}
      <CTASection />

      {/* Footer - Company info, links, and legal */}
      <Footer />

      {/* Floating Action Buttons - Scroll to Top */}
      <ScrollToTopFab />

      {/* Floating Action Button - WhatsApp Chat */}
      <WhatsAppFab />
    </Box>
  );
};

export default LandingAnimated;
